// this is not a test file, only happens to have "-test" filename suffix:
// eslint-disable-next-line ember/no-test-import-export
export default {
  testMetric(value, newsletter) {
    if (newsletter.automaticWinner && !value) {
      return "can't be blank";
    }

    return true;
  },

  testDuration(value, newsletter) {
    if (!newsletter.automaticWinner) {
      return true;
    }

    if (!value) {
      return "can't be blank";
    }

    if (value < 0) {
      return 'must be greater than 0';
    }

    return true;
  },
};
